exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.archive-icon[data-v-7e1a2d34] {\n        padding-top: 3px;\n        font-size: .85em;\n}\n[data-v-7e1a2d34]::-webkit-input-placeholder {\n   font-style: italic;\n}\n[data-v-7e1a2d34]:-moz-placeholder {\n   font-style: italic;\n}\n[data-v-7e1a2d34]::-moz-placeholder {\n   font-style: italic;\n}\n[data-v-7e1a2d34]:-ms-input-placeholder {  \n   font-style: italic;\n}    \n", ""]);

// exports
